var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order-money"},[_c('span',[_vm._v(_vm._s(_vm.moneyFenArr[0]))]),(_vm.moneyFenArr[1])?_c('span',{staticClass:"money-fen"},[_vm._v("."+_vm._s(_vm.moneyFenArr[1]))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }